'use client'

import CommentsList from "@/src/components/common/comments/comments-list";
import StyledDivider from "@/src/components/common/styled-divider/styled-divider";
import useCommentForm from "@/src/hooks/useCommentForm";
import { Box, Typography } from "@mui/material";
import { faMessages } from "@fortawesome/pro-duotone-svg-icons";
import {type CommentFormProps} from "@/src/_types/Comment/comment";

const CommentsComponent = ({ url = '', comments = [], bgColor = 'white' }: CommentFormProps) => {
    const { replyTo, handleReply } = useCommentForm();

    return (
        <>
            <StyledDivider
                label={"comments"}
                icon={faMessages}
            />
            <Box
                bgcolor={bgColor}
                p={{
                    xs: 1,
                    sm: 1,
                    md: 2
                }}
            >
                <Typography 
                    color="primary.main" 
                    fontSize={'1.5rem'}
                >
                    Leave a comment here
                </Typography>
                <Box
                    component={"iframe"}
                    src={`${url}${replyTo ? `/${replyTo}` : ''}`}
                    width={"100%"}
                    minHeight={730}
                    border={0}
                ></Box>
                <CommentsList
                    comments={comments}
                    handleReply={handleReply}
                />
            </Box>
        </>
    )
}

export default CommentsComponent;